import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { CardStyleInterpolators } from "@react-navigation/stack";
import { SuggestType } from "@towersystems/roam-common/lib/generated-types";
import { ModalCloseButton } from "@towersystems/roam-common-native";
import { EditQuickKeyRootParamList } from "../../../../types";
import { useFullTextSearch } from "../../../../utilities/fulltext-search";
import { FulltextProductSearchContext } from "../../../../utilities/fulltext-search/context";
import { createStackHeaderNavigator } from "@towersystems/roam-common-native";
import { ColorPickerScreen } from "../ColorPickerScreen";
import { EditActionQuickKeyScreen } from "../EditActionQuickKeyScreen";
import { EditFilterQuickKeyRootScreen } from "../EditFilterQuickKeyRootScreen";
import { EditProductQuickKeyRootScreen } from "../EditProductQuickKeyRootScreen";

export type EditQuickKeyRootScreenProps = NativeStackScreenProps<
  EditQuickKeyRootParamList,
  "EditQuickKeyRootScreen"
>;

const commonScreenOptions = {
  animationEnabled: true,
};

export const EditQuickKeyRootScreen = ({
  navigation,
  route,
}: EditQuickKeyRootScreenProps) => {
  const Stack = createStackHeaderNavigator<EditQuickKeyRootParamList>();

  const productFullTextSearch = useFullTextSearch({
    type: SuggestType.PRODUCT,
    responseType: "complete",
  });

  return (
    <FulltextProductSearchContext.Provider value={productFullTextSearch}>
      <Stack.Navigator>
        <Stack.Group
          screenOptions={{
            ...commonScreenOptions,
            headerShown: true,
            headerLeft: () => <ModalCloseButton type="Close" />,
          }}
        >
          <Stack.Screen
            name="EditActionQuickKeyScreen"
            component={EditActionQuickKeyScreen}
            options={{ title: "Edit Action Quick Key" }}
          />
          <Stack.Screen
            name="EditProductQuickKeyRootScreen"
            component={EditProductQuickKeyRootScreen}
            options={{ title: "", headerShown: false }}
          />
        </Stack.Group>
        <Stack.Group screenOptions={commonScreenOptions}>
          <Stack.Screen
            name="EditFilterQuickKeyRootScreen"
            component={EditFilterQuickKeyRootScreen}
            options={{ title: "Edit Filter Quick Key", headerShown: false }}
          />
        </Stack.Group>
      </Stack.Navigator>
    </FulltextProductSearchContext.Provider>
  );
};
